<template>
    <th
        :id="id"
        class="bg-blue-light-300 font-bold border border-gray-400 p-2"
        :class="{ 'cursor-pointer' : sort && id }"
        :data-search="search"
        v-on="sort && id ? { click: () => handleSort() } : {}"
    >
        <slot />
        <i
            class="fas fa-sort-up fa-fw relative top-1 ml-1"
            aria-hidden="true"
            v-if="id == state.currentCol[tableId] && state.currentDir[tableId] == 'asc'"
        >
        </i>
        <i
            class="fas fa-sort-down fa-fw relative -top-0.5 ml-1"
            aria-hidden="true"
            v-if="id == state.currentCol[tableId] &&  state.currentDir[tableId] == 'desc'"
        >
        </i>
    </th>
</template>

<script>
import { Inertia } from '@inertiajs/inertia'

import store from '../store';

export default {
    props: {
        id: {
            type: String,
        },
        sort: {
            type: Boolean,
            default: true
        },
        search: {
            type: Boolean,
            default: true
        },
        sorted: {//If it needs to be sorted on load by this column (for clientside)
            type: Boolean,
            default: false
        },
    },
    setup(props, { attrs, slots }) {
        const tableId = store.state.currentTableId;//So we know to which table this th belongs

        if (store.state.side[store.state.currentTableId] == 'server') {
            const urlQueryString = window.location.search
            const urlParams = new URLSearchParams(urlQueryString);

            //When sort server side, check url for params and change state
            if (urlParams.has('column') && urlParams.has('direction')) {
                store.changeCol({column: urlParams.get('column'), id: store.state.currentTableId})
                store.changeDir({dir: urlParams.get('direction'), id: store.state.currentTableId})
            }
        }

        if (props.sorted)
        {
            handleSort()
        }

        function handleSort() {

            //Set the direction
            if(props.id === store.state.currentCol[store.state.currentTableId]) {
                if (store.state.currentDir[store.state.currentTableId] === 'asc') {
                    store.changeDir({dir: 'desc', id: store.state.currentTableId})
                } else {
                    store.changeDir({dir: 'asc', id: store.state.currentTableId})
                }
            }

            //Set the column and sort the values
            store.changeCol({column: props.id, id: store.state.currentTableId})

            if (store.state.side[store.state.currentTableId] == 'client') {
                store.sortValues({id: store.state.currentTableId});
            } else {
                //Server side
                Inertia.get(
                    window.location.href,
                    {
                        column: props.id,
                        direction: store.state.currentDir[store.state.currentTableId],
                        search: store.state.currentSearch[store.state.currentTableId],
                    },
                    {
                        replace: true,
                        preserveState: true
                    }
                )
            }


            // console.log(store.state.currentTableId + " - " + store.state.currentCol[store.state.currentTableId] + ' - ' + store.state.currentDir[store.state.currentTableId]);
        }

        return {
            state: store.state,
            ...store,
            tableId,
            handleSort,
        };
    },
}
</script>
